import { fetchBrands, setToken } from './../../api';

// Funzione per validare un token, al momento non avendo trovato un' api per validare il token sfrutto una rotta, se mi ritorna i dati
// sono autenticato, se mi ritorna unauthorized significa che non lo sono
export const validateToken = async (params = {}) => {

    const parameters = {...params}
    // Estraggo il token dai parameters
    const { token } = parameters

    if(!token) return false
    // E lo imposto, questo metodo lo imposta nei client
    setToken(token)

    try {
        //console.warn('isValid', isValid)
        return await fetchBrands()
            .then(() => true)
            .catch((err) => {
                //console.error('Errore nel fetchBrands:', err)
                return false
            });

    } catch (error) {
        // nel caso esploda qualcosa fuori da fetchBrands
        console.error('Errore generale:', error)
        return false
    }
}

export const  getSubFromToken = (token) => {
    try {
        const base64Payload = token.split('.')[1];

        // Convert base64url to base64 standard
        const base64 = base64Payload
                .replace(/-/g, '+')
                .replace(/_/g, '/')
            + '='.repeat((4 - base64Payload.length % 4) % 4);

        // Decode base64 → binary → string
        const binary = atob(base64); // ok anche se deprecato, ancora compatibile
        const jsonPayload = new TextDecoder().decode(
            Uint8Array.from(binary, c => c.charCodeAt(0))
        );

        const payload = JSON.parse(jsonPayload);
        return payload.sub;
    } catch (err) {
        console.error("Errore nel parsing del token:", err);
        return null;
    }
}